import { $authHost } from './index';

export const fetchCounterparties = async () => {
  const res = await $authHost.get('api/counterparty');
  return res.data;
};

export const createCounterparty = async (payload) => {
  const res = await $authHost.post('api/counterparty', payload);
  return res.data;
};

export const fetchCounterpartyDebts = async () => {
  const res = await $authHost.get('api/counterparty/debts');
  return res.data;
};

export const addCounterpartyPayment = async (counterpartyId, payload) => {
  const res = await $authHost.post(`api/counterparty/${counterpartyId}/payment`, payload);
  return res.data;
};

export const updateCounterpartyDebt = async (counterpartyId, payload) => {
  const res = await $authHost.patch(`api/counterparty/${counterpartyId}/debt`, payload);
  return res.data;
};


